import { render } from "./Board.vue?vue&type=template&id=3c3d985c&scoped=true"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"

import "./Board.vue?vue&type=style&index=0&id=3c3d985c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c3d985c"

export default script